import { ControlPropertyType } from '../../../enums';

export const AutocompleteFilterStrategy = {
  Async: 'async',
  Sync: 'sync',
};

export const AutocompleteFilterType = {
  Includes: 'includes',
  StartsWith: 'startsWith',
};

export const AutocompleteProperty = {
  ...ControlPropertyType,
  FillType: 'fillType',
  Multiple: 'multiple',
  Options: 'options',
  NoValueOption: 'noValueOption',
  FilterStrategy: 'filterStrategy',
  FilterType: 'filterType',
  SearchHandler: 'searchHandler',
  IsLoading: 'isLoading',
};
